import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { pickHTMLProps } from 'pick-react-known-prop';
var useStyles = makeStyles({
  'position-start': {
    paddingRight: '0.2em'
  },
  'position-end': {
    paddingLeft: '0.2em'
  }
}, {
  name: 'SxFieldPreviewNakedAdornment'
});

function FieldPreviewNakedAdornment(_ref) {
  var children = _ref.children,
      pClasses = _ref.classes,
      className = _ref.className,
      position = _ref.position,
      rest = _objectWithoutProperties(_ref, ["children", "classes", "className", "position"]);

  var classes = useStyles({
    classes: pClasses
  });
  return /*#__PURE__*/React.createElement("span", _extends({}, pickHTMLProps(rest), {
    className: clsx(classes.root, classes["position-".concat(position)], className)
  }), children);
}

FieldPreviewNakedAdornment.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.shape({
    root: PropTypes.string
  }),
  className: PropTypes.string,
  position: PropTypes.oneOf(['start', 'end']).isRequired
};
FieldPreviewNakedAdornment.defaultProps = {
  children: undefined,
  classes: undefined,
  className: undefined
};
export default FieldPreviewNakedAdornment;